const lxConfig = {
  index_pv: 'c_fsp_dcep_muau9sq5',
  ai_btn_mc: 'b_fsp_dcep_dyhcn2s0_mc',
  ruler_btn_mc: 'b_fsp_dcep_64n62guj_mc',
  submit_btn_mv: 'b_fsp_dcep_r4qetnur_mv',
  submit_btn_mc: 'b_fsp_dcep_r4qetnur_mc',
  link_mv: 'b_fsp_dcep_zlbfn0yp_mv',
  link_mc: 'b_fsp_dcep_zlbfn0yp_mc',
  ecny_home_modal_mv: 'b_fsp_dcep_xjh3kowl_mv',
  ecny_home_modal_ok_mc: 'b_fsp_dcep_xjh3kowl_mc',
  ecny_home_modal_cancel_mc: 'b_fsp_dcep_u01z1mva_mc',
  failpage_pv: 'c_fsp_dcep_b81c80cp',
  failpage_gohome_btn_mc: 'b_fsp_dcep_5ps98ubg_mc',
  enterpage_pv: 'c_fsp_dcep_0n6xyvjm',
  bankSelect_mv: 'b_fsp_dcep_cdrhw5gn_mv',
  bankSelect_mc: 'b_fsp_dcep_cdrhw5gn_mc',
};

export { lxConfig };
